import {
  IndexFredCode,
  useGetEconomicIndexQuery
} from 'generated/graphql';
import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';



export interface IData {
  name: string;
  rate: string;
}



export function useQuery() {
  const years = [DateTime.now().year];
  const tuple = useGetEconomicIndexQuery({
    variables: {
      options: {
        filter: {
          economicIndex: [
            'DGS1MO',
            'DGS3MO',
            'DGS6MO',
            'DGS1',
            'DGS3',
            'DGS5',
            'DGS7',
            'DGS10',
            'DGS20',
            'DGS30'
          ],
          years
        }
      }
    }
  });

  return React.useMemo(
    () => {
      const results = tuple.data?.economicIndices
        .filter((economicIndex) => treasuryCodes.includes(economicIndex.fredCode))
        .map((node) => {
          const dataPoint = node.mostRecentValue;
          const index = treasuryCodes.indexOf(node.fredCode);
          return {
            index,
            name: __investmentNames[index],
            rate: dataPoint.round(2).toString()
          };
        }) ?? [];

      const data: IData[] = _.sortBy(results, (r) => r.index);
      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



const treasuryCodes: IndexFredCode[] = [
  'DGS1MO',
  'DGS3MO',
  'DGS6MO',
  'DGS1',
  'DGS2',
  'DGS3',
  'DGS5',
  'DGS7',
  'DGS10',
  'DGS20',
  'DGS30'
];

const __investmentNames = [
  '1M',
  '3M',
  '6M',
  '1Y',
  '2Y',
  '3Y',
  '5Y',
  '7Y',
  '10Y',
  '20Y',
  '30Y'
];
